import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { ChatAttachmentFile } from "web_myplann/Chat/Components/ChatAttachmentFile";
import { ChatAttachmentImage } from "web_myplann/Chat/Components/ChatAttachmentImage";
import { ChatMessageBubble } from "web_myplann/Chat/Components/ChatMessageBubble";
import { formatChatTime } from "web_myplann/Chat/Helpers/chatFormatting";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";

type Props = {
	message: ChatMessageView;
};

export const ChatSenderMessage: FC<Props> = ({ message }) => {
	const theme = useTheme();
	const { message: messageTheme, sender, timestamp } = theme.chat;
	const { content, attachments } = message;

	return (
		<ChatMessageBubble alignment="end" pending={message.pending}>
			{attachments.map((attachment) =>
				attachment.isImage ? (
					<ChatAttachmentImage
						key={attachment.id}
						attachmentId={attachment.id}
						fileName={attachment.fileName}
					/>
				) : (
					<ChatAttachmentFile
						key={attachment.id}
						fileName={attachment.fileName}
						backgroundColor={sender.attachmentBackground}
						color={sender.textColor}
					/>
				),
			)}

			{content && (
				<Typography
					className="chat_bubble"
					variant="body2"
					color={sender.textColor}
					px={messageTheme.paddingX}
					py={messageTheme.paddingY}
					lineHeight={messageTheme.lineHeight}
					style={{ background: sender.background }}
				>
					{content}
				</Typography>
			)}

			<Typography
				className="chat_group_tail"
				variant="hint"
				pr={timestamp.inset}
			>
				{formatChatTime(message.createdAt)}
			</Typography>
		</ChatMessageBubble>
	);
};
